import React, { Component } from 'react';
import { bool, func, shape } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from '../../../../container';
import Home from '../../../home/components/Home';
import Header from '../Header';
import { ROUTE_HOME, ROUTE_LOGIN } from '../../../../routes';

/**
 * Private route
 * Custom react-router route
 */
class PrivateRoute extends Component {
  static propTypes = {
    component: func.isRequired,
    unauthorized: bool.isRequired,
    me: shape().isRequired,
  };

  render() {
    const { component: Component, unauthorized, me, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={(props) => {
          const currentRoute = props.location.pathname;
          const isHome = currentRoute === ROUTE_HOME;
          const isAuthenticated = get('authenticator').isAuthenticated();

          if (isAuthenticated) {
            // Check if profile is loaded
            if (Object.keys(me).length === 0) {
              return null;
            }

            return (
              <div>
                <Header />
                <Component {...props} />
              </div>
            );
          }

          if (isHome && !unauthorized) {
            return <Home {...props} />
          }

          return <Redirect to={{ pathname: ROUTE_LOGIN, state: { from: currentRoute } }} />;
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  unauthorized: state.auth.unauthorized,
  me: state.profile.me,
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/modules/common/components/routes/PrivateRoute.js